const ProvincesService = function (APIService) {
    const self = this;

    self.getProvincesByProvinceIds = function (provinceIds) {
        return APIService.Provinces.getProvincesByProvinceIds(provinceIds);
    }

    self.getProvinceById = function(provinceId) {
        return APIService.Provinces.getProvinceById(provinceId);
    }
}

angular.module('dashboard')
    .service('ProvincesService', ['APIService', ProvincesService]);
